import React, {
    useEffect,
    useRef
} from 'react';
import {
    Animated,
    View
} from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
    placeholder: { marginVertical: 2 },
    container: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
});

export const TextPlaceholder = ({
    width = '100%',
    height = 16,
    borderRadius = 4,
    backgroundColor = '#C1C9EE',
    highlightColor = '#F2F8FC',
    animationDuration = 700,
    style,
}) => {
    const animatedValue = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        const startAnimation = () => {
            Animated.sequence([
                Animated.timing(animatedValue, {
                    toValue: 1,
                    duration: animationDuration,
                    useNativeDriver: false,
                }),
                Animated.timing(animatedValue, {
                    toValue: 0,
                    duration: animationDuration,
                    useNativeDriver: false,
                }),
            ])
                .start(() => startAnimation());
        };

        startAnimation();
    }, [ animatedValue,
        animationDuration ]);

    const animatedBackgroundColor = animatedValue.interpolate({
        inputRange: [ 0,
            1 ],
        outputRange: [ backgroundColor,
            highlightColor ],
    });

    return (
        <Animated.View
            style={[
                styles.placeholder,
                {
                    width,
                    height,
                    borderRadius,
                    backgroundColor: animatedBackgroundColor,
                },
                style,
            ]}
        />
    );
};

export const MultiLineTextPlaceholder = ({
    lines = 3,
    lineHeight = 16,
    lineSpacing = 8,
    lastLineWidth = '60%',
    style,
    ...placeholderProps
}) => {
    return (
        <View style={[ styles.container,
            style ]}>
            {Array.from({ length: lines }, (_, index) => (
                <TextPlaceholder
                    key={index}
                    height={lineHeight}
                    width={index === lines - 1 ? lastLineWidth : '100%'}
                    style={{ marginBottom: index < lines - 1 ? lineSpacing : 0 }}
                    {...placeholderProps}
                />
            ))}
        </View>
    );
};
